require('../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/analytics.template.htm');
var Queue_Statistics_Template = require('text-loader!../templates/queue_statistics.template.htm');
require('dhtmlxMessage');
var QueuesStatisticsCollection = require('../models/queues_statistics.paginated.collection.ts');
var VenuesCollection = require('../models/venues.paginated.collection.ts');
require('../../libs/amcharts/amcharts.js');
require('../../libs/amcharts/serial.js');
require('jqueryUI');
require('jqueryUIDatePickerEnglish');
require('jqueryUIDatePickerGreek');
var i18n = require("l10n");
var colors = require('../../libs/assets/colors.js');


var TheView = GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	queue_statistics_template: Handlebars.compile(Queue_Statistics_Template),
	superInitialize: GenericView.prototype.initialize,
	options: [],
	from: $.datepicker.formatDate('yy-mm-dd', new Date()),
	to: $.datepicker.formatDate('yy-mm-dd', new Date()),
	initialize: function () {
	    var self = this;

	    this.venues_collection = new VenuesCollection();
        this.loadVenues();
	},
	loadVenues: function()
	{
	    var self = this;

        this.venues_collection.url = '/rest/api/venues';
        this.venues_collection.on( 'sync', this.successVenuesData, this );
        this.venues_collection.on( 'error', this.errorVenuesData, this );
        this.venues_collection.getFirstPage();
	},
	successVenuesData: function(response)
    {
    	//this.clearData();
    	this.render();
        var venueId = $($($('#nav-tab').find("a.active"))[0]).attr("data-venueId");
        this.loadQueueStatistics(venueId);
    },
    errorVenuesData: function(venues_collection, xhr, options)
    {
    	this.onErrorHandler(venues_collection, xhr, options);
    },
    loadQueueStatistics: function(venueId)
    {
        var self = this;
        this.queues_statistics_collection = new QueuesStatisticsCollection();

     	this.queues_statistics_collection.url = "/rest/api/statistics/venues/"+venueId+"/queues?extra=queue&filter="
     	                                    + encodeURIComponent("date>=" + this.from + ", date<=" + this.to) + "&group=queue";
     	this.queues_statistics_collection.on( 'sync',
     	    function() {
     	        self.successQueueStatisticsData(venueId);
     	    }
     	, this );
     	this.queues_statistics_collection.on( 'error', this.errorQueueStatisticsData, this );
     	this.queues_statistics_collection.getFirstPage();
    },
	successQueueStatisticsData: function(venueId)
	{
        var currentvenue =  $("#venue-"+venueId);
        if (this.queues_statistics_collection.models.length != 0) {
            currentvenue.find("#chartdiv-card").show();
            currentvenue.find("#errorqueues").hide();
            this.fillChartData(venueId);
        }
        else
        {
            currentvenue.find("#chartdiv-card").hide();
            currentvenue.find("#errorqueues").show();
        }
	},
    errorQueueStatisticsData: function(queues_statistics_collection, xhr, options)
    {
        this.onErrorHandler(queues_statistics_collection, xhr, options);
    },
    fillChartData: function (venueId)
    {
        var self = this;
        var dataProvider = [];

		for(var i = 0; i< this.queues_statistics_collection.models.length; i++)
		{
            var tempModel = this.queues_statistics_collection.models[i];
			var tempObj = {
			    "queue_name":  Handlebars.helpers.getQueueNameForLang(tempModel.attributes.queue),
			    "maxWaitTime": tempModel.attributes.queuestatistic.maxWaitTime,
			    "avgWaitTime": tempModel.attributes.queuestatistic.averageWaitTime
            };

            dataProvider.push(tempObj);

		}

        this.renderStatistics(venueId);

        var chart = AmCharts.makeChart( "chartdiv-" +venueId, {
            "type": "serial",
            "addClassNames": true,
            "theme": "light",
            "autoMargins": true,
            "balloon": {
                "adjustBorderColor": false,
                "horizontalPadding": 10,
                "verticalPadding": 8
            },
            "legend": {
                "useGraphSettings": true,
                "markerSize":12,
                "valueWidth":0,
                "verticalGap":0
            },
            "dataProvider": dataProvider,
            "valueAxes": [ {
                "axisAlpha": 0.2,
                "position": "top",
                "dashLength" : 3,
                "minorGridEnabled": true,
                "minorGridAlpha": 0.08,
                "gridAlpha": 0.15
            } ],
            "startDuration": 1,
            "graphs": [
                {
                    "alphaField": "alpha",
                    "balloonText": "<span style='font-size:13px;'>[[title]] " + i18n.t("analytics.in_queue") + " [[category]]:<b> [[value]] "+ i18n.t('dashboard.minutes') + "</b></span>",
                    "fillAlphas": 1,
                    "title": i18n.t("analytics.max_time"),
                    "type": "column",
                    "valueField": "maxWaitTime",
                    "dashLengthField": "dashLengthColumn",
                    "fillColors" : colors.purple,
                    "lineAlpha" : 0,
                    "fillAlphas" : 0.8,
                    "fixedColumnWidth": 30,
                    "bulletBorderColor": colors.purple
                },
                {
                    "id": "graph2",
                    "type" : "line",
                    "lineColor" : colors.blue,
                    "balloonText": "<span style='font-size:13px;'>[[title]] " + i18n.t("analytics.in_queue") + " [[category]]:<b> [[value]] "+ i18n.t('dashboard.minutes') + "</b></span>",
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": colors.blue,
                    "bulletBorderColor": colors.blue,
                    "bulletBorderThickness": 2,
                    "lineThickness": 2,
                    "fillAlphas": 0,
                    "title": i18n.t("analytics.avg_time"),
                    "valueField": "avgWaitTime"
                }
            ],
            "rotate": true,
            "categoryField": "queue_name",
            "categoryAxis": {
                "gridPosition": "start",
                "axisAlpha": 0,
                "tickLength": 0,
                "axisColor" : "#DADADA",
                "dashLength" : 3
            },
            "export": {
                "enabled": true
            }
        } );

        $("#chartdiv-"+venueId).css("height", (dataProvider.length * 45) + 'px');
    },
    renderStatistics: function(venueId) {
       $("#queues_statistics-"+venueId).html(this.queue_statistics_template( {"queue_statistics": this.queues_statistics_collection.models}) );
       this.loadQueueCharts();
    },
    addVenueOption: function(id, name)
    {
		this.addOption("v"+id, name, false);
    },
    addQueueOption: function(id, name)
	{
		this.addOption("q"+id, name, true);
	},
	addOption: function(id, name, isQueue)
	{
		this.options = this.options.concat([{ id: id, name: name, isQueue: isQueue}]);
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();

        this.$el.html(this.template( { "venues" : this.venues_collection.models } ));
        this.initializeDatePicker();
	},
	events:{
  		"click .nav-item": "changeTab",
  		"click #filterForDates": "filterForDates",
  		"change input.date" : "validateDates"
    },
    changeTab: function(event)
    {
        $($($("#nav-tab").find("a.active"))[0]).removeClass("active");
        $(event.target).addClass("active");

        var venueId = $($($('#nav-tab').find("a.active"))[0]).attr("data-venueId");
        this.loadQueueStatistics(venueId);

    },
    initializeDatePicker: function()
    {
        var self = this;

        $.datepicker.setDefaults( $.datepicker.regional[ i18n.lng() ] );

        var datepickerOptions = {
            //"yearRange": (yearFrom +":"+ yearTo),
            "dateFormat": "yy-mm-dd",
             maxDate: '+0d'
        };

        var starting = $('#startingDate');
        starting.datepicker(datepickerOptions);
        starting.val(this.from);

        var ending = $('#endingDate');
        ending.datepicker(datepickerOptions);
        ending.val(this.to);
    },
    filterForDates: function() {
        //this.validateDates();
        var inputFrom = $("#startingDate");
        var inputTo = $("#endingDate");

        var dateFrom = new Date(inputFrom.val());
        var dateTo = new Date(inputTo.val());


        var validDates = true;

        if(dateFrom instanceof Date && !isNaN(dateFrom))
            inputFrom.removeClass("error");
        else
        {
            validDates = false;
            inputFrom.addClass("error");
        }

        if(dateTo instanceof Date && !isNaN(dateTo))
            inputTo.removeClass("error");
        else
        {
            validDates = false;
            inputTo.addClass("error");
        }

        if(!validDates)
        {
            $.notify(i18n.t("analytics.invalid_date"), { position:"top center", className: "error" });
            return;
        }

        if(dateFrom > dateTo)
        {
            $.notify(i18n.t("analytics.less_than"), { position:"top center", className: "error" });
            inputTo.addClass("error");
            return;
        }

        this.from = inputFrom.val();
        this.to = inputTo.val();
        this.loadQueueStatistics($(".analyticsTabButton.active").data("venueid"));
    },
    validateDates: function(event)
    {

        var element = $(event.currentTarget);
        var date = new Date(element.val());

        if(date instanceof Date && !isNaN(date))
            element.removeClass("error");
        else
        {
            element.addClass("error");
        }

    },
    loadQueueCharts: function()
    {
        for(var i = 0; i< this.queues_statistics_collection.models.length; i++)
        {
            var tempModel = this.queues_statistics_collection.models[i];
            var chart = $("#donut_chart-q" + tempModel.attributes.queue.id );

            var servedTickets = tempModel.attributes.queuestatistic.servedCount;
            var pendingTickets = tempModel.attributes.queuestatistic.pendingCount;
            var cancelledTickets = tempModel.attributes.queuestatistic.cancelledCount;
            // var totalAppointments = tempModel.attributes.queuestatistic.totalAppointments;
            var missedAppointments = tempModel.attributes.queuestatistic.missedAppointments;

            var data = [servedTickets, pendingTickets, cancelledTickets, missedAppointments];
            var colours = [colors.purple, colors.blue, colors.mustard, colors.green];
            var labels = [i18n.t("analytics.served"), i18n.t("analytics.pending"), i18n.t("analytics.cancelled"), i18n.t("analytics.missedAppointments")];
            var percentageValues = [0.20, 0.20, 0.20, 0.20]; //initial values

            var maxValue = data[0];
            for(var j=1; j < data.length; j++) {
                if(maxValue < data[j])
                    maxValue = data[j];
            }

            var totalValues = 0;
            for(var j=0; j<data.length; j++)
                totalValues += data[j];

            if(maxValue > 0 && totalValues > 0) {
                for(var j=0; j<data.length; j++) {
                    if(data[j] <= 0)
                        percentageValues[j] = 0;
                    else
                        percentageValues[j] = data[j]/totalValues;
                }
            }

            this.createDonutCharts(chart, data, colours, labels, percentageValues);

            //$("#perCentServed-q" + tempModel.attributes.queue.id).html(+perCentServed + "%");
        }

    },
    createDonutCharts: function(chart, data, colours, labels, percentageValues)
    {
        var self = this;
        var legendDivId = "legend-" + chart.attr("id");
        var myChart = new Chart( chart, {
            type: 'doughnut',
            data: {
              labels: labels,
              datasets: [
                {
                  backgroundColor: colours,
                  data: percentageValues
                }
              ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutoutPercentage: 60,
                radius: 50,
                autoMargins: false,
                autoResize: false,
                legend: {
                    display: false,
                    align: "left",
                    divId: legendDivId,
                    position: "bottom",
                    forceWidth: false,
                    equalWidths: true,
                    valueWidth: "250px",
                    labelWidth: "250px",
                    switchable: true
                },
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    callbacks: {
                        label: function(tooltipItems, pieceData) {
                            return pieceData.labels[tooltipItems.index] + ": " + data[tooltipItems.index];
                        }
                    }
                }
            }
        });

        myChart.customLegend = chart.parent().find(".q-statistic-legend");

        for(var i=0; i<data.length; i++) {
            var color = colours[i];
            var value = data[i];
            var label = labels[i];

            myChart.customLegend.append('<div class="legend-item" id="legend-item-' + i + '" style="background-color: #fff;">' +
                                            '<div class="legend-marker" style="background: '+ color + '; width: 12px; height: 12px; display: inline-block; margin-right: 0.5rem;"></div>' +
                                            '<div class="legend-value" style="display: inline-block;">' +
                                                '<span style="color: #7e7e7e">' + label + ':</span> <b style="color: ' + color + '";>' + value  + '</b>' +
                                            '</div>' +
                                      '</div>');
        }
    }
});


module.exports = TheView;